import React, { useState } from 'react';
import { Button, Grid, TextField, IconButton, InputAdornment } from '@mui/material';
import { Link } from 'react-router-dom';
import { LinkStyled, ParagraphForgotPassword } from './LoginForm.styled';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export const LoginForm = ({
  formData,
  handleChange,
  handleSubmit,
  isLogining,
  handleForgotPassword,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  
  const handleClickShowPassword = () => setShowPassword((prev) => !prev);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };


  return (
    <form onSubmit={handleSubmit} noValidate>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Email"
            type="email"
            variant="outlined"
            fullWidth
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Password"
            type={showPassword ? 'text' : 'password'}
            variant="outlined"
            fullWidth
            name="password"
            value={formData.password}
            onChange={handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <ParagraphForgotPassword onClick={handleForgotPassword}>
            Password dimenticata?
          </ParagraphForgotPassword>
        </Grid>
        <Grid item xs={12}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isLogining}
          >
            Accedi
          </Button>
        </Grid>
        <Grid item xs={12}>
          <LinkStyled component={Link} to="/register">
            Non sei ancora registrato? Registrati
          </LinkStyled>
        </Grid>
        <Grid item xs={12}></Grid>
      </Grid>
    </form>
  );
};